<template>
  <div id="dashboard-page">
    <b-row>
      <b-col md="6" class="py-1">
        <pie-attendance></pie-attendance>
      </b-col>
      <b-col md="6" class="py-1">
        <pie-leave></pie-leave>
      </b-col>
      <!-- <b-col md="4" class="py-1">
        <bar-overtime></bar-overtime>
      </b-col> -->
    </b-row>
    <b-row class="mt-3">
      <b-col md="6">
        <request-list></request-list>
      </b-col>
      <b-col md="6" class="py-1">
        <bar-reimburs></bar-reimburs>
      </b-col>
      <!-- <b-col md="4">
        <sales></sales>
      </b-col> -->
    </b-row>
  </div>
</template>
<script>
import AttendanceCart from '@/components/dashboard/PieAttendance';
import card from '@/components/CardGlasses';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import PieAttendance from '../components/dashboard/PieAttendance.vue';
import PieLeave from '../components/dashboard/PieLeave.vue';
import BarReimburs from '../components/dashboard/BarReimburs.vue';
import BarOvertime from '../components/dashboard/BarOvertime.vue';
import RequestList from '../components/dashboard/RequestList.vue';
import Sales from '../components/dashboard/Sales.vue';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

export default {
  name: 'NavigationBar',
  components: {
    card,
    AttendanceCart,
    PieAttendance,
    PieLeave,
    BarReimburs,
    BarOvertime,
    RequestList,
    Sales,
  },

  data() {
    return {};
  },
};
</script>

<style scoped>
.card-custom {
  border: 1px solid #fff;
  border-radius: 18px;
  /* box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.2); */
  font-size: 2rem;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.card-custom:before {
  /* background-color: rgba(232, 244, 252, 0.082); */
  background-color: #fff;
  /* backdrop-filter: blur(10px) saturate(100%) contrast(45%) brightness(130%); */
  content: '';
  color: black;
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>
